import { useToast } from "@chakra-ui/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import queryKey from "configs/queryKey";
import {
  AddOrUpdateTokenInfoParams,
  addTokenInfo,
  updateTokenInfo,
} from "utils/apiService/TokenInfo";

interface IProps {
  onClose: () => void;
  reset: () => void;
  id?: string;
}
const useAddOrUpdateTokenInfo = ({ onClose, reset, id }: IProps) => {
  const toast = useToast();
  const queryClient = useQueryClient();
  return useMutation(
    async (params: AddOrUpdateTokenInfoParams) =>
      id ? await updateTokenInfo(id, params) : await addTokenInfo(params),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKey.TOKEN_INFO]);
        onClose();
        reset();
        toast({
          title: "Token info",
          description: "Successfully",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
      },
      onError: async (errors: any) => {
        const devMessage = errors?.response?.data?.devMessage || [];
        const errorMessage = errors?.response?.data?.errorMessage || "";
        const description = errorMessage + ":" + devMessage?.join(", ") || "";

        toast({
          title: "Token info",
          description,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      },
    }
  );
};

export default useAddOrUpdateTokenInfo;
